export default (state, {payload}) => {
  let newState = Object.assign({}, state);
  newState.isRequesting = payload;
  newState.requesting += payload ? 1 : -1;
  if (newState.isRequesting === true) {
    newState.lastError = null;
    newState.lastErrorDescription = '';
  }
  return newState;
};
